import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';
import { runMutationOnce, runQueryOnce } from '@/pages/shared/rtk-query-helpers';

/**
 * The three export endpoints return raw CSV text, so they read the body as text rather
 * than letting `fetchBaseQuery` guess: the payload is handed straight to a Blob and a
 * JSON-parsed object would serialise as "[object Object]".
 */
export const exportDocumentApi = createApi({
    reducerPath: 'exportDocumentApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        exportDocuments: builder.mutation({
            query: (settings) => ({
                url: '/api/exportMetadata/documents',
                method: 'POST',
                body: settings,
                responseHandler: 'text',
            }),
        }),
        exportCer: builder.mutation({
            query: (settings) => ({
                url: '/api/exportMetadata/cer',
                method: 'POST',
                body: settings,
                responseHandler: 'text',
            }),
        }),
        exportContacts: builder.mutation({
            query: (accountId) => {
                const params = new FormData();
                params.append('accountId', accountId);

                return {
                    url: '/api/exportMetadata/contacts',
                    method: 'POST',
                    body: params,
                    responseHandler: 'text',
                };
            },
        }),
        availableAccountsList: builder.query({
            query: () => ({ url: '/api/accounts/availableAccounts', method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
    }),
});

/**
 * Runs an `exportDocumentApi` query once and releases its cache subscription.
 */
export const runExportDocumentQuery = (dispatch, endpointName, arg) =>
    runQueryOnce(dispatch, exportDocumentApi.endpoints[endpointName], arg);

/**
 * Runs an `exportDocumentApi` mutation once and clears its tracked entry.
 */
export const runExportDocumentMutation = (dispatch, endpointName, arg) =>
    runMutationOnce(dispatch, exportDocumentApi.endpoints[endpointName], arg);

export default exportDocumentApi;
